import { Link, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { FC, MouseEventHandler } from 'react'
import AppModal from '../../../../components/AppModal/AppModal'
import theme from '../../../../theme'
import AboutConfigData from './aboutInfo'

interface AboutProps {
	readonly onCloseModal: MouseEventHandler<Element>
	children?: React.ReactNode
}

interface AboutData {
	key: string | React.Key
	value: string
	valueType: string
	keySx?: {}
	valueSx?: {}
	href?: string
}

interface AboutSegmentProps {
	title?: string | null
	style?: {}
	data: AboutData[]
}

const AboutSegment: FC<AboutSegmentProps> = (props: AboutSegmentProps) => {
	return (
		<Box sx={{ ...props.style, borderColor: theme.palette.secondary.dark }}>
			{props.title && (
				<Box p={4}>
					<Typography variant={'h6'}>{props.title}</Typography>
				</Box>
			)}

			{props.data.map(data => (
				<Box
					key={data.key}
					display={'flex'}
					pl={4}
					pr={4}
					sx={{
						justifyContent: 'flex-start',
					}}
				>
					<Typography sx={{ ...data.keySx }}>{data.key}</Typography>
					{data.valueType === 'text' && (
						<Typography sx={{ ...data.valueSx }}>
							{data.value}
						</Typography>
					)}
					{data.valueType === 'link' && (
						<Link
							href={data.href}
							target={'_blank'}
							sx={{ ...data.valueSx }}
						>
							{data.value}
						</Link>
					)}
				</Box>
			))}
		</Box>
	)
}

const About: FC<AboutProps> = (props: AboutProps) => {
	return (
		<AppModal
			open={true}
			onClose={props.onCloseModal}
			title={'About'}
			width={'45rem'}
		>
			{AboutConfigData.map((data, i: React.Key) => (
				<AboutSegment
					key={i}
					data={data.data}
					title={data.title}
					style={data.style}
				></AboutSegment>
			))}
		</AppModal>
	)
}

export default About
